import { SidebarModalListItem } from '@domain-group/suit-theme'

import { AgencyModel } from '@models/types'

interface MemberListItemProps {
  agency: AgencyModel,
  callbacks: {
    toggleMembers: Function,
  },
}

const MemberListItem = (props: MemberListItemProps) => {
  const {
    agency,
    callbacks: {
      toggleMembers,
    },
  } = props

  return (
    <SidebarModalListItem title={agency.title}>
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon onClick={() => toggleMembers()} type="delete" />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default MemberListItem
